import request from '../common/js/request';


export const requestLogin = data => {
    return request({
        url: '/user/admin/login',
        method: 'post',
        data
    })
};
//修改密码
export const changePassword = data => {
    return request({
        url: '/user/changePassword',
        method: 'post',
        data
    })
};

export const requestLogout = () => {
    return request({
        url: '/user/admin/logout',
        method: 'get'
    })
};
// 请求商户列表
export const getMerchantListPage = data => {
    return request({
        url: '/merchant/selectPage',
        method: 'post',
        data
    })
};

// 添加商家
export const addMerchant = data => {
    return request({
        url: '/merchant/insert',
        method: 'post',
        data
    })
};
// 编辑商家
export const editMerchant = data => {
    return request({
        url: '/merchant/update',
        method: 'post',
        data
    })
};
// 验证商家
export const sendVerify = params => {
    return request({
        url: '/onlineSign/sendVerifyCode',
        method: 'get',
        params
    })
};
// 验证商家
export const verifyMerchant = data => {
    return request({
        url: '/merchant/onlineSign/verifyCode',
        method: 'post',
        data
    })
};
// 启用/禁用商家
export const changeMerchantStatus = data => {
    return request({
        url: '/user/admin/updateState',
        method: 'post',
        data
    })
};

// 添加企业用户
export const addEnterpriseUser = params => {
    return request({
        url: '/onlineSign/addEnterpriseUser',
        method: 'get',
        params
    })
};

// 合同列表
export const getContractList = data => {
    return request({
        url: '/contract/selectPage',
        method: 'post',
        data
    })
};

// 上传交付单
export const updateDeliveryUrl = data => {
    return request({
        url: '/contract/updateDeliveryUrl',
        method: 'post',
        data
    })
};

// 添加签署方，合同列表里增加添加签署方按钮contractStatus !=1(1-生成未签署)不能添加签署方，此按钮不可点击 contractNo
export const addSigner = params => {
    return request({
        url: '/onlineSign/addSigner',
        method: 'get',
        params
    })
};

// 上传待签署文件，合同列表里增加上传待签署文件按钮，contractStatus !=0(未生成)此按钮不可点击,返回合同预览地址 contractNo
export const createContract = params => {
    return request({
        url: '/onlineSign/createContract',
        method: 'get',
        params
    })
};

// 查询合同状态
export const queryContract = params => {
    return request({
        url: '/onlineSign/query',
        method: 'get',
        params
    })
};


// 下载合同接口，在合同列表上有一个下载合同按钮，contractStatus !=2(2-已添加签署方待签署)不能下载，此按钮不可点击 contractNo
export const downloadContract = params => {
    return request({
        url: '/onlineSign/download',
        method: 'get',
        params
    })
};

// 商品分类
export const getProductCategory = params => {
    return request({
        url: '/product/getProductCategory',
        method: 'get',
        params
    })
};

// 商品列表
export const getProductList = data => {
    return request({
        url: '/product/selectPage',
        method: 'post',
        data
    })
};

// 添加商品
export const addProduct = data => {
    return request({
        url: '/product/insert',
        method: 'post',
        data
    })
};

// 商品详情
export const getProductDetail = data => {
    return request({
        url: '/product/detail',
        method: 'post',
        data
    })
};

// 修改商品 根据id
export const updateProduct = data => {
    return request({
        url: '/product/update',
        method: 'post',
        data
    })
};

// 订单列表
export const getOrderList = data => {
    return request({
        url: '/order/selectPage',
        method: 'post',
        data
    })
};

// 订单公证 orderNo
export const orderNotary = params => {
    return request({
        url: '/order/orderNotary',
        method: 'get',
        params
    })
};


// 添加合同 在订单列表上有一个录入合同按钮
export const addContract = data => {
    return request({
        url: '/contract/insert',
        method: 'post',
        data
    })
};


// 上传
export const fileUpload = (data, setter) => {
    return request({
        url: '/oss/fileUpload',
        method: 'post',
        data,
        ...setter
    })
};


/**
 * 获取用户基本信息
 * @param params
 * @returns {*}
 */
export const getCustomer = params => {
    return request({
        url: '/enterOrder/getCustomer',
        method: 'get',
        params
    })
}

/**
 * 录入定单
 * @param data
 * @returns {*}
 */
export const setOrderEnter = data => {
    return request({
        url: '/enterOrder/setOrderEnter',
        method: 'post',
        data
    })
}

/**
 * 获取用户文件
 * @param params
 * @returns {*}
 */
export const getEnterFile = params => {
    return request({
        url: '/enterFile/getEnterFile',
        method: 'get',
        params
    })
}

/**
 * 录入文件
 * @param data
 * @returns {*}
 */
export const attachment = data => {
    return request({
        url: '/enterFile/attachment',
        method: 'post',
        data
    })
}

/**
 * 获取公证书相关信息
 * @param params
 * @returns {*}
 */
export const getNotarization = params => {
    return request({
        url: '/enterNotarization/getNotarization',
        method: 'get',
        params
    })
}
/**
 * 生成公证书
 * @param data
 * @returns {*}
 */
export const generateNotarization = data => {
    return request({
        url: '/enterNotarization/generateNotarization',
        method: 'post',
        data
    })
}


/**
 * 公证书视频录入
 */
export const queryVideo = params => {
    return request({
        url: '/enterNotarization/queryVideo',
        method: 'get',
        params
    })
}

/**
 * 获取公证书
 * @param params
 * @returns {*}
 */
export const queryBook = params => {
    return request({
        url: '/enterNotarization/queryBook',
        method: 'get',
        params
    })
}

/**
 * 删除定单
 * @param params
 * @returns {*}
 */
export const delOrder = params => {
    return request({
        url: '/contract/delOrder',
        method: 'get',
        params
    })
}


// WEBPACK FOOTER //
// ./src/api/api.js